import { color } from "@styles";
import { P1, P2 } from "components/atoms/Paragraph";
import React, { ComponentProps, FC } from "react";
import { types, RichText } from "react-bricks/frontend";
import styled from "styled-components";

type Props = Pick<
  ComponentProps<typeof RichText>,
  "propName" | "placeholder" | "renderPlaceholder" | "renderBlock"
> &
  ComponentProps<typeof P1>;

const TextBlock: FC<Props> = ({
  propName,
  placeholder = `Enter text here...`,
  renderBlock,
  renderPlaceholder,
  ...pProps
}) => {
  return (
    <RichText
      propName={propName}
      placeholder={placeholder}
      allowedFeatures={[
        types.RichTextFeatures.Link,
        types.RichTextFeatures.Bold,
        types.RichTextFeatures.Subscript,
      ]}
      renderLink={({ children, href, target, rel }) => (
        <A href={href} target={target} rel={rel}>
          {children}
        </A>
      )}
      renderBlock={({ children }) => {
        return <TextContent {...pProps}>{children || " "}</TextContent>;
      }}
      renderPlaceholder={renderPlaceholder}
      renderSub={({ children }) => {
        return (
          <Footnote {...pProps} color={color.B2100}>
            {children || " "}
          </Footnote>
        );
      }}
    />
  );
};

export default TextBlock;

const A = styled.a`
  color: ${color.P100};
  text-decoration: underline;
`;

const TextContent = styled(P1)`
  padding-top: 0;
  line-height: 1.9rem;
  &:empty {
    margin-top: 2rem;
  }
`;

const Footnote = styled(P2)`
  padding-top: 0;
  line-height: 1.3rem;
  &:empty {
    margin-top: 1.3rem;
  }
`;
